import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const AssetPreviewContext = /*#__PURE__*/createContext(undefined);
export default function AssetPreviewProvider({
  applicationId,
  objectId,
  children,
  objectType,
  onUpdateCrmObject,
  originObjectType,
  previewType,
  readOnly
}) {
  const value = useMemo(() => ({
    applicationId,
    objectId,
    objectType,
    onUpdateCrmObject,
    originObjectType,
    previewType,
    readOnly
  }), [applicationId, objectId, objectType, onUpdateCrmObject, originObjectType, previewType, readOnly]);
  return /*#__PURE__*/_jsx(AssetPreviewContext.Provider, {
    value: value,
    children: children
  });
}
export function useAssetPreview() {
  const context = useContext(AssetPreviewContext);
  if (context === undefined) {
    throw new Error('useAssetPreview must be used within a AssetPreviewProvider');
  }
  return context;
}